import {
  Paper,
  Stack,
  TextField,
  InputAdornment,
  IconButton,
  Checkbox,
  Collapse,
  FormControlLabel,
  Tooltip,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { MIN_SEARCH_LENGTH } from '../../../utils/searchConstants';
import { ClearFiltersButton, ScanIconButton } from '../../common/components';

interface ProductFiltersProps {
  show: boolean;
  filterName: string;
  onFilterNameChange: (value: string) => void;
  filterCode: string;
  onFilterCodeChange: (value: string) => void;
  showOnlyActive?: boolean;
  onShowOnlyActiveChange?: (value: boolean) => void;
  onClearFilters: () => void;
}

export const ProductFilters = ({
  show,
  filterName,
  onFilterNameChange,
  filterCode,
  onFilterCodeChange,
  showOnlyActive,
  onShowOnlyActiveChange,
  onClearFilters,
}: ProductFiltersProps) => {
  return (
    <Collapse in={show}>
      <Paper sx={{ p: 2, mb: 2, backgroundColor: 'background.default' }} variant="outlined">
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
          <TextField
            label="Пошук за назвою"
            variant="outlined"
            size="small"
            fullWidth
            value={filterName}
            onChange={(e) => onFilterNameChange(e.target.value)}
            helperText={filterName.length > 0 && filterName.length < MIN_SEARCH_LENGTH ? `Введіть щонайменше ${MIN_SEARCH_LENGTH} символів для пошуку` : ' '}
            sx={{ flexGrow: 1 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
              endAdornment: filterName && (
                <InputAdornment position="end">
                  <Tooltip title="Очистити">
                    <IconButton size="small" onClick={() => onFilterNameChange('')}>
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Пошук за кодом"
            variant="outlined"
            size="small"
            fullWidth
            value={filterCode}
            onChange={(e) => onFilterCodeChange(e.target.value)}
            helperText=" "
            sx={{ flexGrow: 1 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  {filterCode && (
                    <Tooltip title="Очистити">
                      <IconButton size="small" onClick={() => onFilterCodeChange('')}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                  <ScanIconButton
                    onDetected={(value) => onFilterCodeChange(value)}
                    tooltip="Сканувати код"
                  />
                </InputAdornment>
              ),
            }}
          />
        </Stack>
        {onShowOnlyActiveChange && (
          <FormControlLabel
            control={(
              <Checkbox
                checked={showOnlyActive ?? true}
                onChange={(e) => onShowOnlyActiveChange(e.target.checked)}
              />
            )}
            label="Показувати лише активні"
            sx={{ mt: 1, ml: 0 }}
          />
        )}
        {(filterName || filterCode) && (
          <ClearFiltersButton onClick={onClearFilters} />
        )}
      </Paper>
    </Collapse>
  );
};
